export default {
  companyParent: '',
  companyChild: '',
  disabled: false,
  showParent: true,
}
